export const locale = {
    lang: 'es',
    data: {
      'WIZARD': {
            'TITULO' : 'Encuesta a colaboradores nuevos',
            'DESCRIPCION': 'Dentro de esta sección podrás ver los nuevos colaboradores que han realizado la encuesta',
            'SEARCH':'Buscar',
            'FILTER':'Escriba el nombre el colaborador que desee buscar',
            'FILTERCT':'Centro(s) de trabajo',
            'CLAVE':'Clic para copiar la liga ',
            'ALERT':{
              'BTN1':'Sí',
              'BTN2':'No',
              'LABEL01':'Aún no ha dado de alta a ningún médico',
              'LABEL02':'Aún no hay citas agendadas',
              'LABEL03':'Seguro que desea continuar con esta acción',
            },
         
            
        }
      }
};
